import { httpsCallable } from "firebase/functions";
import { functions } from "./ambiente";

/**
 * Cutuca quem ainda não postou hoje. Quem decide se pode (horário, uma
 * por pessoa por dia) é o servidor; a recusa vem em português.
 */
export async function cutucar(cid: string, alvo: string): Promise<void> {
  const chamar = httpsCallable<{ cid: string; alvo: string }, { ok: boolean }>(functions, "nhomiCutucar");
  await chamar({ cid, alvo });
}
